<template>
	<div>
		<div class="top_tabs" v-if="option.type">
			<van-tabs @click="onClick" class="top_tabs_title">
				  <van-tab title="全部内容"></van-tab>
				  <van-tab title="膳食记录" v-if="feedbackObj.foodFeedback != null"></van-tab>
				  <van-tab title="生成表现" v-if="classFeedback.length != 0"></van-tab>
			</van-tabs>	
		</div>
		<div :class="'container '+(option.type==1?'hb':'')" ref="imageWrapper01">
			<div class="container_m">
				<div class="container-bg">
					<div class='nav'>
						<div class='nav-title'>
						<span>520托宝</span>
						</div>
					</div>
					<div class='frame-active overflow'>
						<!-- header user info -->
						<div class="frame-header">
							<div class="header-left">
								<van-image
								  width="3rem"
								  height="3rem"
								  fit="cover"
								  round
								  :src="feedbackObj.photo"
								/>
							</div>
							<div class="header-right">
								<div class="header-info">
									<div class="info-name">
										<span class="text-white">{{feedbackObj.studentName}}</span>
										<span>同学</span>
									</div>
									<div class="info-time">
										<span>晚上好，{{feedbackObj.studentName}}家长~</span>
									</div>
								</div>
							</div>
						</div>
						<!-- level info -->
						<div class="frame-level frame-outsize">
							<div class="frame-content">
								<div class="frame-level-content">
									<div class="level-left">
										<div>
											亲爱的{{feedbackObj.studentName}}宝贝:
										</div>
										<div class="level-time">
											今天是 <span class="text-blue">{{dateTimeStr}}</span>
										</div>
										<div>
											你已在{{orgObj.orgName}}学习了<span class="text-danger">{{feedbackObj.inSchoolDay}}天</span>了
										</div>
									</div>
									<div class="level-right">
										<div class="level-img" v-if="feedbackObj.level">
											<img src="@/assets/medal-bg.png" class="level-img-bg"></img>
											<img :src="'/assets/select'+feedbackObj.level+'.png'" :class="'level-img-medal'+(feedbackObj.level > 3 ? '':'img-medal-size')"></img>
										</div>
									</div>
								</div>
								<div class="text-info">我们一起见证了你的成长,每天进步一点点，加油宝贝</div>
							</div>
						</div>
						<!-- class participation  -->
						<div :class="'frame-class '+(option.type==3?'hb':'')" v-if="classFeedback.length != 0" ref="imageWrapper03">
							<div class="class-title">
								<img src="@/assets/index-class-icon.png"></img>
								<span>成长表现</span>
							</div>
							<div class="frame-outsize class-content">
								<div class="class-nav">
									<span v-for="item,index in classFeedback" :class="classIndex == index ? 'active' : ''"  bindtap="handleChangeNav">{{item.label}}</span>
								</div>
								<div class="frame-content c">
									<div class="class-info text-routine">
										<div class="info-content">
											<div class="class-info-img">
												<van-image  fit="cover" round width="30" height="30" :src="classFeedbackObj.staff.photo" />
											</div>
											<div class="class-info-name">{{classFeedbackObj.staff.staffName}}老师</div>
											<div class="class-info-icon">
												<!-- <van-icon name="arrow" /> -->
											</div>
										</div>
										<div class="info-time">
											<span>{{classFeedbackObj.time}}</span>
										</div>
									</div>
									<div class="class-desc">{{classFeedbackObj.remark}}</div>
									<div class="class-star">
										<span class="text-blue">老师点评</span>
										<van-rate
											:value="classFeedbackObj.levels"
											:size="15"
											color="#ffd21e"
											void-icon="star"
											readonly />  
									</div>
									<block v-if="classFeedbackObj.imgs.length != 0">
										<div class="class-img" v-for="child,ind in classFeedbackObj.imgs">
											<div class="item-img">
												<img :src="child" mode="aspectFill"/>
											</div>
										</div>          
									</block>
								</div>
							</div>
							<div class="qc" v-if="option.type==3">
								<div class="left">
									识别二维码，<br>了解更多动态。
								</div>
								<div class="right">
									<img :src="qc"/>
								</div>	
							</div>
						</div>
						<!-- eat -->
						<div :class="'frame-eat '+(option.type==2?'hb':'')" v-if="feedbackObj.foodFeedback != null" ref="imageWrapper02">
							<div class="eat-title">
								<img src="@/assets/index-food-icon.png"></img>
								<span>营养膳食</span>
							</div>
							<div class="eat-content frame-outsize">
								<div class="frame-content">
									<div class="eat-desc">
										{{feedbackObj.foodFeedback.remark}}
									</div>
									<block v-if="feedbackObj.foodFeedback.imgs.length != 0">
										<div class="eat-img" v-for="item,index in feedbackObj.foodFeedback.imgs">
											<div class="item-img">
												<img :src="item" mode="aspectFill"/>
											</div>
										</div>
									</block>
								</div>
							</div>
							<div class="qc" v-if="option.type==2">
								<div class="left">
									识别二维码，<br>了解更多动态。
								</div>
								<div class="right">
									<img :src="qc"/>
								</div>	
							</div>
						</div>
						<!-- org -->
						<div class="frame-org">
							<div class="org-title">
								<img src="@/assets/index-location-icon.png"></img>
								<span>了解机构</span>
							</div>
							<div class="org-content frame-outsize">
								<div class="frame-content">
									<div class="org-info">
										<div class="info-left">
											<img :src="orgObj.icon" />
										</div>
										<div class="info-right">
											<div>
												<span class="text-routine">机构：</span>
												<span>{{orgObj.orgName}}</span>
											</div>
											<div>
												<span class="text-routine">电话：</span>
												<span>{{orgObj.telephone||'没设置电话'}}</span>
											</div>
											<div>
												<span class="text-routine">地址：</span>
												<span>{{orgObj.address||'没设置地址'}}</span>
											</div>
										</div>
									</div>
									<div class="org-report" v-if="popularizeList.length != 0">
										<div class="popularize-item-img" v-for="item,index in popularizeList">
											<a :href="item.url?item.url:'javascript:;'">
												<img :src="item.photo"/>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="qc" v-if="option.type==1">
				<div class="left">
					识别二维码，<br>了解更多动态。
				</div>
				<div class="right">
					<img :src="qc"/>
				</div>	
			</div>
				
			</div>
		</div>
		<!-- <img v-if="imgUrl!=''" :src="imgUrl" style="width: 100%;height: auto;"/> -->
	</div>
	
</template>

<script>
	import { Toast } from 'vant';
	import { Image as VanImage } from 'vant';
	var _Domain="https://api.tb.1698.me";
	// var _Domain="http://192.168.0.19:9001";
	var _DomainPic="https://files.tb.1698.me/img/";
	
	import html2canvas from "html2canvas"
	
	export default {
	  components:{},
	  data(){
		   return {
				imgUrl:"",
				qc:"",
				classList:[],
				classIndex:0,
				dateTimeStr:null,
				value: 2.5,
				current:0,
				option:{},
				feedbackObj:{},
				classFeedback:[],
				classFeedbackObj:{},
				orgObj:{},
				popularizeList:[],
				imList:[],
				hideChatLen:0,
				toRef:""
		   }
	   },
	   mounted(){ //页面加载完成后执行
			let that=this;
			let options=this.$route.query;
			this.option=options;
			this.dateTimeStr=this.formatTime(new Date(options.shareTime));	
			if(options.type){
				let _url=encodeURIComponent("https://files.tb.1698.me/#/?studentId="+this.option.studentId+"&userId="+this.option.userId+"&shareTime="+this.dateTimeStr+"&orgId="+this.option.orgId);
				this.http_post("https://naihui.huaweiedu.com.cn/index.php/integral/weixin/getQcBase64",{
					text:_url
				},function(res){
					if(res.error==0){
						that.qc=res.msg;
						that.getInit();
					}else{
						Toast(res.msg);
					}
				});
			}else{
				that.getInit();
			}
			
	   },
	   methods: {
			onClick(e){
				let that=this;
				that.option.type=e+1;
				setTimeout(function(){
					that.toImage();
				},1000)
				
			},
			getInit(){
				let that=this;
			    let params = {
			        studentId:this.option.studentId,
			        userId:this.option.userId,
			        dateStr:this.dateTimeStr,
			        orgId:this.option.orgId
			    };
				
				this.http_get("/huawei/nursery/feedback/userFeedback",params,function(res){
					if(res.code==0) {
						
					    let obj = res.data;
					    obj.photo = that.getDefaultStuHead(obj.photo,obj.gender);        
					    var arr = [];
					    
					    let studentObj = {
					        studentId:obj.studentId,
					        studentName:obj.studentName,
					        gender:obj.gender,
					        photo:obj.photo
					    }
						
					    if(obj.classFeedbacks.length != 0) {
					        for(var i=0;i<obj.classFeedbacks.length;i++){
					            let item = obj.classFeedbacks[i];
					            item.staff.photo =that.getDefaultUserHead(item.staff.photo,item.staff.gender);      
					            if(item.photos != ''){
					                let imgs = item.photos.split(',');
					                item.imgs = imgs;
					                arr.push(item)
					            }
					        }
					    }
					    if(obj.foodFeedback!=null&&obj.foodFeedback.remark!=""){
					        obj.foodFeedback.imgs = obj.foodFeedback.photos != '' ?  obj.foodFeedback.photos.split(','):[];
					        if(obj.foodFeedback.staff){
								obj.foodFeedback.staff.photo = that.getDefaultUserHead(obj.foodFeedback.staff.photo,obj.foodFeedback.staff.gender);  
							}
						}else{
							obj.foodFeedback=null;
						}
						that.feedbackObj=obj;
						
						
						that.classFeedback=arr;
						that.classFeedbackObj=arr[0]||{};
						that.orgObj=res.data.org;
						that.popularizeList=res.data.popularize;
						if(that.option.type){
							setTimeout(function(){
								that.toImage();
							},1000);
						}
					} else {
						Toast(res.msg);
					}
				})
			},
			getOrgInfo(){
			    let staffObj = storage.getStorage('staffParams');
			    let params = {
			        orgId:staffObj.orgId
			    }
			},
			handleChangeNav(event){
				this.classIndex=event.currentTarget.dataset['index'];
				this.classFeedbackObj=this.classFeedback[event.currentTarget.dataset['index']];
			},
			getDefaultUserHead(_url,_tag=1){
				var _headImgUrl=_url;
				if(_headImgUrl){
				   return _headImgUrl;
				}
				//身份判断
				switch(_tag){
				  case 1: // 爸爸
				    _headImgUrl="/assets/head/head01.png";
				  break;
				  case 2: //妈妈
				    _headImgUrl="/assets/head/head02.png";
				  break;
				  case 3: //爷爷
				    _headImgUrl="/assets/head/head06.png";
				  break;
				  case 4: //奶奶
				    _headImgUrl="/assets/head/head03.png";
				  break;
				  case 5: //外公
				    _headImgUrl="/assets/head/head08.png";
				  break;
				  case 6: //外婆
				    _headImgUrl="/assets/head/head07.png";
				  break;
				  default: //亲人
				    _headImgUrl="/assets/head/head01.png";
				  
				}
				return _headImgUrl;
			},
			getDefaultStuHead(_url,_sex=1){
			  var _headImgUrl=_url;
			  if(_headImgUrl){
			     return _headImgUrl;
			  }
			  //身份判断
			  switch(_sex){
			    case "男": // 男孩
			      _headImgUrl="/assets/head/head04.png";
			    break;
			    default: //女孩
			      _headImgUrl="/assets/head/head05.png";
			    
			  }
			  return _headImgUrl;
			},
			formatTime(date,str=false){
			  date = new Date(date);
			  if(str){
			    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
			  }else{
			    return `${date.getFullYear()}-${(date.getMonth() + 1)<10?"0":""}${(date.getMonth() + 1)}-${date.getDate()<10?"0":""}${date.getDate()}`;
			  }
			},
			http_get(url,params,callback){
				this.$http.get(_Domain+url,{params:params})
				.then(res => {
					// post 成功，response.data 为返回的数据
					callback&&callback(res.data);
				}).catch(error => {
					// 请求失败
					console.log(error)
				});
			},
			http_post(url,params,callback){
				this.$http.get(url,{params:params})
				.then(res => {
					// post 成功，response.data 为返回的数据
					callback&&callback(res.data);
				}).catch(error => {
					// 请求失败
					console.log(error)
				});
			},
			toImage(){
				let that=this;
				if(that.option.type==2){ //膳食
					that.toRef="imageWrapper02"
				}else if(that.option.type==3){ //课堂
					that.toRef="imageWrapper03"
				}else{ //全部
					that.toRef="imageWrapper01"
				}
				html2canvas(that.$refs[that.toRef],{
					useCROS: true,
					dpi:300
				}).then(canvas => {
				  let dataURL = canvas.toDataURL("image/png");
				  let str=dataURL.split("base64,");
				  that.imgUrl = dataURL;
				  if(str[1]){
					  that.$http.post("https://files.tb.1698.me/huawei/file/uploadFileBase64",{photo:str[1]},
					  {headers: {'Content-Type':'application/json'}})
					  .then(res => {
						  if(res.data.code==0){
							  wx.miniProgram.postMessage({
								data: {
								  code:0,
								  img:res.data.data,
								  msg:"生成成功"
								},
							  });
						  }else{
							  wx.miniProgram.postMessage({
									data: {
									  code:-1,
									  msg:"生成失败"
									},
							  });
						  }
					  }).catch(error => {
					  	// 请求失败
					  	console.log(error)
					  });
					 
				  }else{
					  wx.miniProgram.postMessage({
						data: {
						  code:-1,
						  msg:"生成失败"
						},
					  });
				  }
				});
		  }
	   },
	}
</script>

<style>
	body{padding: 0;margin: 0;}
	.top_tabs{
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		z-index: 99;
		box-shadow: 0px 2px 10px rgba(0,0,0, 0.2);
	}
	.top_tabs_title .van-tab--active{
		color: #1989fa;
		font-weight: bold;
		font-size:.9rem;
	}
	.top_tabs_title .van-tabs__line{
		background-color:#1989fa
	}
	.nav{
		height:3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
	}
	.container{
	   background: linear-gradient(#f0f7fd,32rem, #fff);
		margin: 0;
		padding: 0;
		position: relative;
		padding-bottom:8rem;
	}
	
	.item-img{
		height: 12rem;
		overflow: hidden;
		border-radius:10px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.item-img img{
		width: 100%;
		height: auto;
	}
	
	.container-bg{
	    background-image: url('./assets/index-top-bg.png');
	    background-size: 100% 20rem;
	    background-repeat: no-repeat;
	}
	
	.container.hb{
		padding: 1rem;
		padding-bottom:7rem;
		background: #1989fa;
		margin-top: 2.8rem;
		margin-bottom: 6rem;
	}
	.container.hb .container-bg{

	}
	.container.hb .container_m{
		background:#f0f7fd;
		border-radius: 8px;
	}
	
	.frame-active{
	    padding:1rem;
	}
	.frame-header{
	    display: flex;
	}
	.frame-header .header-left{
	    margin-right: .5rem;
	}
	.frame-header .header-right{
	    width: calc(100% - 3rem);
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}
	.frame-header .header-right .header-info{
	    color: #B8DBFF;
	}
	.frame-header .header-right .header-info .info-name{
	    font-size: 1rem;
	}
	.frame-header .header-right .header-info .info-name span:first-child{
	    margin-right: .4rem;
		color: #fff;
	}
	.frame-header .header-right .header-info .info-name span:last-child{
	    color: #FFFFFF;
	}
	.frame-header .header-right .header-info .info-time{
	    margin-top: .2rem;
	    font-size: .9rem;
	}
	.text-info{
		color: #666;
	}
	.frame-outsize{
	    background: #FFFFFF;
	    border-radius: 1.2rem;
	    position: relative;
	    box-shadow: 0px 6px 30px rgba(97, 178, 255, 0.2);
	}
	.frame-outsize .frame-content{
	    padding: 1rem;
	}
	.frame-outsize .frame-content.c{
		background: linear-gradient(#f0f7fd,3rem, #fff);
	}
	/* level */
	.frame-level{
	    margin-top: 1.5rem;
	}
	.frame-level-content{
	   display: flex; 
	   font-size: .9rem;
	}
	.frame-level div:last-child{
	    font-size:.8rem;
	}
	.frame-level div>img{
		    width: 7rem;
	}
	.frame-level .level-left{
	    width: calc(100% - 35%);
	}
	.frame-level .level-left>div{
	    line-height: 1.4rem;
	    font-size: .9rem;
	    font-weight: bold;
	}
	.frame-level .level-left>div:first-child{
	    font-size:.9rem;
		margin-bottom: .4rem;
		font-weight: normal;
		color: #7d7d7d;
	}
	.frame-level .level-left .level-time{
	    display: flex;
	    align-items: center;
	    
	}
	.frame-level .level-left .level-time>div{
	    width:.9rem;
	    height:.96rem;
	    margin-left:.4rem;
	}
	.frame-level .level-right{
	    width: 30%;
	    text-align: center;
	    font-size: .9rem;
	}
	.frame-level .level-right .level-img{
		height: 5.8rem;
	    position: relative;
	    top: 0rem;
	}
	.frame-level .level-right .level-img .level-img-bg{
		width: 8.3rem;
		height: 6.2rem;
		position: absolute;
		top: -4rem;
		left: 0rem;
	}
	.frame-level .level-right .level-img .level-img-medal{
	    width:7rem;
	    height:6.2rem;
	    position: absolute;
	    top: 1.35rem;
	    left:.5rem;
	}
	.frame-level .level-right .level-img .img-medal-size{
	    width:6.8rem;
	    height:5.6rem;
	    top: .4rem;
	    left: -.3rem;
	}
	/* class */
	.frame-eat,.frame-say,.frame-org{
	    margin-top: 1.35rem;
	}
	.frame-class{
		position: relative;
		margin-top: 1.5rem;
	}
	.frame-class.hb{
		padding: 1rem;
		padding-bottom:4rem;
		background: #1989fa;
	}
	.frame-class.hb .class-title{
		display: none;
	}
	
	.frame-eat.hb{
		padding: 1rem;
		padding-bottom:4rem;
		background: #1989fa;
		position: relative;
	}
	.frame-eat.hb .eat-title{
		display: none;
	}
	
	.frame-class .class-title img,
	.frame-eat .eat-title img,
	.frame-say .say-title img,
	.frame-org .org-title img{
	    width: 1rem;
	    margin-right: .5rem;
	}
	.frame-class .class-title{
		margin-bottom: .4rem;
	}
	.frame-class .class-title, .frame-eat .eat-title,.frame-say .say-title,.frame-org .org-title{
	    font-size: 1rem;
	    padding: .5rem 0;
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
	    font-weight: bold;
		color: #555;
	}
	.frame-class .class-nav{
	    background-image:url('./assets/index-nav1.png');
	    background-size: 100% 100%;
	    background-repeat:no-repeat;
	    padding:.5rem .6rem;
	}
	.frame-class .class-nav span{
	    display: inline-block;
	    padding: .1rem .6rem .2rem;
	    color: #D5EAFF;
	    font-size: .8rem;
	}
	.frame-class .class-nav span.active{
	    border-top-left-radius: .2rem;
	    border-top-right-radius: .2rem;
	    color: #333333;
	    font-weight: bold;
	}
	
	.frame-class .class-nav span.active:after{
		width: 80%;
		height: .2rem;
		border-radius: 4rem;
		background: #59AEFF;
		display: block;
		content: '';
		margin: 0 auto;
		margin-top: .2rem;
	}
	
	.class-content .class-info{
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    font-size: .9rem;
	}
	.class-content .class-info span{
		color:#9c9c9c;
	}
	.class-content .info-content{
	    border-radius:10px;
	    padding: .1rem .2rem;
	    display: flex;
	    align-items: center;
	}
	.class-content .info-content .class-info-img{
	    
	    margin-right:.5rem
	}
	.class-content .class-desc,.eat-content .eat-desc {
	    font-size: 1rem;
	    margin-bottom: 1rem;
	    margin-top: 0.8rem;
	    color: #333;
	}
	.eat-content .eat-desc{
	    margin-top: 0;
	}
	.class-content .class-img, .eat-content .eat-img{
	    border-radius:10px;
	    overflow: hidden;
	    margin-top: .5rem;
	}
	.class-content .class-img img, .eat-content .eat-img img{
	    vertical-align: bottom;
	}
	.info-content .class-info-name{
		color: #666;
	}
	.class-content .class-star{
	    margin-top: .5rem;
	    font-size: .9rem;
	    padding: .4rem 0;
	}
	.class-content .class-star .text-blue{
		margin-right: .4rem;
		color: #666;
	}
	.btn-tools {
	    display: flex; 
	    justify-content: space-between;
	    align-items: center;
	    padding-top: .8rem;
	}
	.btn-tools>div{
	    padding: 0 .27rem;
	}

	.btn-tools button {
	    border: 0;
	}
	.btn-tools button van-icon{
	    font-size: 1.1rem;
	}
	
	.btn-tools>div{
	    border-radius:10px;
	    padding: .1rem .3rem;
	    display: flex;
	    align-items: center;
	    font-size: .8rem;
	    border: 1px solid #409EFF;
	    background: #ECF5FF;
	    color: #409eff;
	}
	.btn-tools>div span{
	    font-size: .6rem;
	    margin-left: .2rem;
	}
	.btn-tools>div.active{
	    filter: grayscale(100%);
	    filter: gray;
	}
	/* org */
	.org-content .org-info{
	   display: flex;
	   align-items: top;
	}
	.org-content .org-info .info-left{
	    margin-right:1rem;
		width: 4rem;
		height:4rem;
		overflow: hidden;
		border-radius: 8px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #efefef;
	}
	.org-content .org-info .info-left img{
		width:120%;
		height: auto;
	}
	.org-content .org-info .info-right{
	    width: calc(100% - 4.7rem);
	    font-size:.8rem;
	    line-height: 1.2rem;
	}
	.org-content .org-info .info-right div{
	    display: flex;
	    align-items: top;
		margin-bottom: .1rem;
	}
	.org-content .org-info .info-right div span:first-child{
	    width: 2.7rem;
		color: #6b6b6b;
	}
	.org-content .org-info .info-right div span:last-child{
	    width: calc(100% - 2.7rem);
	    font-size: .8rem;
	}
	.org-content .org-report {
	    width: 100%;
	    position: relative;
	    margin-top: 1.1rem;
	}
	.org-content .org-report .org-report-text{
	    border-top-left-radius: .6rem;
	    background: rgba(0,0,0,.3);
	    padding: .2rem .5rem;
	    position: absolute;
	    bottom: 0;
	    right: 0;
	    color: #FFFFFF;
	    font-size: .8rem;
	}
	.share-btn{
	    width: 100%;
	    border-radius:1.3rem;
	    background: #1189FF;
	    color: #ffffff;
	    text-align: center;
	    font-size:1rem;
	    padding:.5rem 0;
	    margin: .8rem 0;
	}
	.share-btn span{
	    margin-left: .3rem;
	}
	.popularize-item-img img{
		width: 100%;
		height: auto;
		border-radius: 8px;
	}
	.qc{
		position: absolute;
		bottom: 1.5rem;
		right: 3rem;
		width:calc(100% - 4rem);
		display: flex;
		
	}
	.qc .left{
		text-align: right;
		flex: 1;
		height:1rem;
		padding-top: 3.6rem;
		font-size: .9rem;
		color: #fff;
	}
	.qc .right{
		padding: .5rem;
		background: #fff;
		width:6rem;
		margin-left:.5rem;
		border-radius:10px;
	}
	.qc img{width: 100%;height:auto;}
</style>
